"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfWinningBidOfferDto = instanceOfWinningBidOfferDto;
exports.WinningBidOfferDtoFromJSON = WinningBidOfferDtoFromJSON;
exports.WinningBidOfferDtoFromJSONTyped = WinningBidOfferDtoFromJSONTyped;
exports.WinningBidOfferDtoToJSON = WinningBidOfferDtoToJSON;
exports.WinningBidOfferDtoToJSONTyped = WinningBidOfferDtoToJSONTyped;
var MakeOfferCoBuyerDto_1 = require("./MakeOfferCoBuyerDto");
/**
 * Check if a given object implements the WinningBidOfferDto interface.
 */
function instanceOfWinningBidOfferDto(value) {
    if (!('settlementDate' in value) || value['settlementDate'] === undefined)
        return false;
    if (!('primaryBuyerName' in value) || value['primaryBuyerName'] === undefined)
        return false;
    return true;
}
function WinningBidOfferDtoFromJSON(json) {
    return WinningBidOfferDtoFromJSONTyped(json, false);
}
function WinningBidOfferDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'settlementDate': (new Date(json['settlementDate'])),
        'primaryBuyerName': json['primaryBuyerName'],
        'primaryBuyerEmail': json['primaryBuyerEmail'] == null ? undefined : json['primaryBuyerEmail'],
        'primaryBuyerPhoneNumber': json['primaryBuyerPhoneNumber'] == null ? undefined : json['primaryBuyerPhoneNumber'],
        'coBuyers': json['coBuyers'] == null ? undefined : (json['coBuyers'].map(MakeOfferCoBuyerDto_1.MakeOfferCoBuyerDtoFromJSON)),
        'residentialAddress': json['residentialAddress'] == null ? undefined : json['residentialAddress'],
    };
}
function WinningBidOfferDtoToJSON(json) {
    return WinningBidOfferDtoToJSONTyped(json, false);
}
function WinningBidOfferDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'settlementDate': value['settlementDate'].toISOString(),
        'primaryBuyerName': value['primaryBuyerName'],
        'primaryBuyerEmail': value['primaryBuyerEmail'],
        'primaryBuyerPhoneNumber': value['primaryBuyerPhoneNumber'],
        'coBuyers': value['coBuyers'] == null ? undefined : (value['coBuyers'].map(MakeOfferCoBuyerDto_1.MakeOfferCoBuyerDtoToJSON)),
        'residentialAddress': value['residentialAddress'],
    };
}
